module.exports = __webpack_public_path__ + "assets/close-blue-25cdf4.svg";